import { Search } from "lucide-react";
import { useMapStore } from "../store";

function SearchButton({showActive}: {showActive?: boolean}) {
    const { display, setDisplay } = useMapStore();
    const isExpanded = display === "search";
    
    const handleClick = () => {
        setDisplay(isExpanded ? null : "search");
    }
  
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Escape' && isExpanded) {
            setDisplay(null);
        }
    }
    return (
        <>
            <button 
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                className={`${showActive && isExpanded ? 'bg-ocean-700' : 'bg-transparent'} flex flex-col items-center justify-center gap-2 text-center w-full h-full text-h6 font-semibold text-white outline-offset-[-4px] !outline-white active:bg-ocean-700`}
                aria-expanded={isExpanded}
                aria-controls="map_search"
                id="map_search_button"
                aria-haspopup="dialog"
            >
                <div aria-hidden="true">
                    <Search size={32} />
                    {/* <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="29.313" height="30"><path fill="#fff" d="M27.491 30a1.807 1.807 0 0 1-1.314-.562l-7.042-7.344a1.823 1.823 0 0 1 .06-2.579 9.205 9.205 0 1 0-6.347 2.535 1.823 1.823 0 1 1 0 3.646 12.848 12.848 0 1 1 12.848-12.848 12.723 12.723 0 0 1-2.753 7.953l5.863 6.118A1.822 1.822 0 0 1 27.492 30Z" data-name="Path 544"/></svg> */}
                </div>
                <span>Search</span>
            </button>
        </>
    );
  }

  export default SearchButton
